import React, { useState } from "react";
import { Modal, Form, Row, Col, Button, Result } from 'antd';
import { config } from "util/config";
import { httpClient } from 'util/Api';
import { useHistory } from "react-router-dom";
import * as globalFunction from 'util/GlobalFunction';

export default class ShowResult extends React.Component {
  constructor(props) {
    super();
    this.state = {

    }
  }

  render() {
    let searchParams = new URLSearchParams(window.location.search);
    return (
      <Result
        status={searchParams.get('success') === '1' ? 'success' : 'error'}
        title={searchParams.get('success') === '1' ? 'Payment successful: ' + searchParams.get('number') : 'Payment failed'}
      />
    );
  }
};
